export default __webpack_public_path__ + "static/kink-4ff301b64dae13669db3ed38268eb0bf.png";